// JavaScript Document
//components/configuration/PowerPicker.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
//import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import MomentUtils from '@date-io/moment';
//import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  //KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
//const utils = require('../configuration/DaysettingUtils');

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dateField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 150,
  },
  gridder: {
	  padding: theme.spacing(3)
  }
}));

export default function EventDatePicker(props) {
  	const classes = useStyles();
  	const {date, daysetting, onChange, label} = props;
	//const [dsid, setDsid] = React.useState(0);
	const [selectedDate, setSelectedDate] = React.useState(new Date());

	//handle user changes to date
  	const handleDateChange = (date) => {
		setSelectedDate(date);
		console.log(date);
  	};

	//handle update to parent
  	const handleUpdate = () => {
		//convert selected date to yyyy-mm-dd
		let datetxt = selectedDate.format('YYYY-MM-DD');
		console.log(datetxt);
	  	if(onChange){
			onChange(datetxt, daysetting);
		}
  	};
  	React.useEffect(() => {
		//setMyTime(time);
		//setMyValue(value);
		if(date){
			setSelectedDate(date);
		}
		//if(daysetting){
		//	setDsid(daysetting);
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

  return (
	  <MuiPickersUtilsProvider utils={MomentUtils}>
	  	<Grid container justifyContent="space-around" className={classes.gridder}>
    		<KeyboardDatePicker
          		disableToolbar
          		variant="inline"
          		format="MM/DD/YYYY"
          		margin="normal"
	  			autoFocus={true}
          		id="event-date-picker"
          		label={label}
	  			className={classes.dateField}
          		value={selectedDate}
          		onChange={handleDateChange}
          		KeyboardButtonProps={{
	  				'aria-label': 'change date',
	  			}}
        	/>
		
	  		<Button variant="contained" color="primary" onClick={handleUpdate}>
  				Add
	  		</Button>
	  	</Grid>
	  </MuiPickersUtilsProvider>
  );
}
